import { BaseService } from "./base.service";
import { Http } from '@angular/http';
import { Injectable } from "@angular/core";
import { RequestBuilder } from "../classes/request-builder";
import { Observable } from "rxjs";
import * as Enum from '../utils/enums';

@Injectable()
export class StoricoModuloService extends BaseService {

    constructor(http: Http) {
        super(http)
    }

    /**
     * storico modulo fetch single
     * @param reqBuilder 
     */
    storicoModuloFetchSingle(reqBuilder?: RequestBuilder): Observable<any> {
        let payload
        if (reqBuilder) {
            payload = reqBuilder
        }
        return this.doPost('storicoModulo/fetchSingle', payload, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON)
    }

    /**
     * storico modulo change status
     * @param reqBuilder 
     */
    storicoChangeStatus(reqBuilder?: RequestBuilder): Observable<any> {
        let payload
        if (reqBuilder) {
            payload = reqBuilder
        }
        return this.doPost('storicoModulo/changeStatus', payload, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON)
    }

    /**
     * storico modulo get versions
     * @param reqBuilder 
     */
    getAllVersions(reqBuilder?: RequestBuilder): Observable<any> {
        let payload
        if (reqBuilder) {
            payload = reqBuilder
        }
        return this.doPost('storicoModulo/getVersions', payload, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON)
    }
}